var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"d-flex align-center"},[_c('v-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.title))])]),_c('v-col',{attrs:{"cols":"6"}},[_vm._t("content",function(){return [_c('p',[_vm._v(_vm._s(_vm.value || _vm.$t('general.empty')))])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }